import AppEnvironment from '@components/enums/appEnvironment.enum';
import { useHistory } from 'react-router-dom';
import { useApplicationContext } from '../../../../../../../modules/context/ApplicationContext/ApplicationContext';
import { useAbility } from '../../../../../../../modules/users/AbilityContext';
import PATHS from '../../../../../../../routes/routes.const';
import { useAppEnvironmentStore } from '../../../../../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../../../../../stores/AppEnvironment/appEnvironment.store.selectors';

const useNavigationLogoClick = (onClick?: () => void) => {
  const history = useHistory();
  const { state } = useApplicationContext();
  const ability = useAbility();
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);
  const isLogoNavigationAllowed =
    !!onClick || isInStoreEnvironment || ability.can('menu', 'showroom');

  const navigateOnLogoClick = () => {
    if (!isLogoNavigationAllowed) {
      return;
    }

    const { appEnvironment } = useAppEnvironmentStore.getState();

    if (appEnvironment === AppEnvironment.STORE) {
      history.push(PATHS.main.home.path);
      return;
    }

    const brandSlug = (state.brand ?? state.user?.brand)?.slug;
    history.push(brandSlug ? `/${brandSlug}` : PATHS.main.home.path);
  };

  return { navigateOnLogoClick: onClick ?? navigateOnLogoClick, isLogoNavigationAllowed };
};

export default useNavigationLogoClick;
